module.exports = "/static/media/qualif.6c5cab0d.svg";